import {
  FETCH_INTERACTION_SUCCESS,
  FETCH_INTERACTION_FAILURE,
  SET_INTERACTION_TOKEN,
  FETCH_SUB_INSTANCES_SUCCESS,
  FETCH_SUB_INSTANCES_FAILURE,
  START_SUB_INSTANCE_SUCCESS,
  START_SUB_INSTANCE_FAILURE,
  FETCH_ITEMS_SUCCESS,
  FETCH_ITEMS_FAILURE,
  UPDATE_ITEMS,
  FETCH_ITEM_METADATA_REQUEST,
  FETCH_ITEM_METADATA_SUCCESS,
  FETCH_ITEM_METADATA_FAILURE,
  FETCH_OUTCOME_TASK_SUCCESS,
  ANSWER_OUTCOME_TASK_SUCCESS,
  SET_CURRENT_ITEM_NUMBER,
  ANSWER_ITEM_FAILURE,
  ANSWER_ITEM_REQUEST,
  ANSWER_ITEM_SUCCESS,
  ANSWER_OUTCOME_TASK_FAILURE,
  ANSWER_OUTCOME_TASK_REQUEST,
  SET_COLOR_VARIANT,
  SET_INTERACTION_INSTANCE_ID,
} from './constants';

import * as interactionService from '@/services/interaction'
import { moveItem } from '@/utils/items'  

import {
    prepareInstanceItems,
    getCurrentItemNumber,
    sanitizeAnswer
} from '@/utils/items'

import { INTERACTION_STATUS } from '@/constants/interaction'

const actions = {
    async fetchInteractionInstance({ commit }, payload) {
        const { interactionInstanceToken } = payload;
        commit(SET_INTERACTION_TOKEN, interactionInstanceToken)
        try {
            const instance = await interactionService.fetchInstance(interactionInstanceToken)
            commit(FETCH_INTERACTION_SUCCESS, instance)
        } catch(e) {
            commit(FETCH_INTERACTION_FAILURE)
        }
    },

    async fetchInstanceItems({ commit, state }, payload) {
        const { interactionInstanceToken } = payload;
        try {
            const interactionItems = await interactionService.fetchInstanceItems(interactionInstanceToken)
            commit(SET_INTERACTION_INSTANCE_ID, interactionItems.interactionInstanceId)

            const preparedInstanceItems = prepareInstanceItems(interactionItems.items)
            commit(FETCH_ITEMS_SUCCESS, preparedInstanceItems)

            const interactionDone = state.interactionInstance.status === INTERACTION_STATUS.FILLED || state.interactionInstance.status === INTERACTION_STATUS.RESULTS_AVAILABLE

            const currentItemNumber = interactionDone ? interactionItems.items.length - 1 : getCurrentItemNumber(preparedInstanceItems)
            commit(SET_CURRENT_ITEM_NUMBER, currentItemNumber)
        } catch(e) {
            console.error(e)
            commit(FETCH_ITEMS_FAILURE, e)
        }
    },

    async fetchSubInstances({ commit }, payload) {
        const { interactionInstanceToken, itemId } = payload;
        try {
            const subInstances = await interactionService.fetchSubInstances(interactionInstanceToken, itemId)
            commit(FETCH_SUB_INSTANCES_SUCCESS, subInstances)
        } catch(e) {
            commit(FETCH_SUB_INSTANCES_FAILURE)
        }
    },

    async startSubInstance({ commit }, payload) {
        const { interactionInstanceToken, itemId, name } = payload;
        try {
            const subInstanceToken = await interactionService.startSubInstance(interactionInstanceToken, itemId, name)
            commit(START_SUB_INSTANCE_SUCCESS, subInstanceToken)
        } catch(e) {
            commit(START_SUB_INSTANCE_FAILURE)
        }
    },
    
    async fetchItemMetaData({ commit }, payload) {
        commit(FETCH_ITEM_METADATA_REQUEST)
        const { interactionInstanceToken, itemId } = payload;
        try {
            const itemMetaData = await interactionService.fetchItemMetaData(interactionInstanceToken, itemId)
            commit(FETCH_ITEM_METADATA_SUCCESS, itemMetaData)
        } catch(e) {
            console.error(e)
            commit(FETCH_ITEM_METADATA_FAILURE)
        }
    },

    async openItem({ commit }, payload) {
        // Opening of items has been disabled intentionally.
        // const { interactionInstanceToken, itemId, timeStamp } = payload;
        // try {
        //     await interactionService.openItem(interactionInstanceToken, { itemId, timeStamp })
        // } catch(e) {
        //     console.error(e)
        // }
    },

    async answerItem({ commit }, payload) {
        const { interactionInstanceToken, itemId } = payload;

        // wrap answer in array if it's a single result (here?)
        const answer = sanitizeAnswer(payload.answer);

        try {
          commit(ANSWER_ITEM_REQUEST);
          await interactionService.answerItem(interactionInstanceToken, itemId, answer);
          commit(ANSWER_ITEM_SUCCESS);
        } catch(e) {
          commit(ANSWER_ITEM_FAILURE, e);
          console.error(e);
        }
    },

    setCurrentItemNumber({ commit }, payload) {
        const { number } = payload;
        commit(SET_CURRENT_ITEM_NUMBER, number);
    },

    async postponeItem({ commit, state }, payload) {
        const { interactionInstanceToken, itemId } = payload;
        try {
            await interactionService.postponeItem(interactionInstanceToken, itemId)

            const newItemIndex = state.interactionItems.findIndex((item, index) => index >= state.currentItemNumber && item.itemType === 'TEXT') - 1;
            const newItems = moveItem(state.interactionItems, state.currentItemNumber, newItemIndex)
            newItems[newItemIndex].postponed = true;
            newItems[newItemIndex].opened = undefined;
        
            commit(UPDATE_ITEMS, newItems)

        } catch(e) {
            console.error(e)
        }
    },

    async fetchOutcomeTaskData({ commit }, payload) {
        const { interactionInstanceToken, itemId } = payload;
        try {
            const outcomeTask = await interactionService.fetchOutcomeTaskData(interactionInstanceToken, itemId)
            commit(FETCH_OUTCOME_TASK_SUCCESS, outcomeTask)
        } catch(e) {
            console.error(e)
        }
    },

    async startOutcomeTask({ commit }, payload) {
        const { interactionInstanceToken, itemId } = payload;
        try {
            await interactionService.startOutcomeTask(interactionInstanceToken, itemId)
        } catch(e) {
            console.error(e)
        }
    },

    async answerOutcomeTask({ commit, state }, payload) {
        const { interactionInstanceToken, itemId, answer } = payload;
        try {
            commit(ANSWER_OUTCOME_TASK_REQUEST)
            const scenarioInstance = await interactionService.answerOutcomeTaskScenario(interactionInstanceToken, itemId, answer)
            commit(ANSWER_OUTCOME_TASK_SUCCESS, scenarioInstance)

            if(scenarioInstance === 'FIN') {
                commit(SET_CURRENT_ITEM_NUMBER, state.currentItemNumber + 1);
            }
        } catch(e) {
            commit(ANSWER_OUTCOME_TASK_FAILURE, e)
            console.error(e)
        }
    },

    setColorVariant({ commit }, payload) {
        commit(SET_COLOR_VARIANT, payload)
    },


    async fetchFountainMap({ commit }, payload) {
        const { externalUserToken } = payload
        try {
            const fountainMap = await interactionService.fetchFountainMap(externalUserToken)
            return fountainMap
        } catch(e) {
            console.error(e)
            throw e
        }
    }
}

export default actions
